import React, { useEffect, useRef } from "react";

const AudioPlayerPopup = ({ isOpen, onClose, name, audioUrl }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !audioUrl) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
      tabIndex="-1"
      role="dialog"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "420px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content shadow border-0" style={{ borderRadius: "8px" }}>
          <div className="modal-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom">
            <h6
              className="modal-title m-0 text-truncate font-weight-bold"
              style={{ maxWidth: "340px", fontSize: "15px" }}
              title={name || "Call Recording"}
            >
              {name || "Call Recording"}
            </h6>
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={onClose}
              style={{
                fontSize: "1.4rem",
                border: "none",
                background: "none",
                cursor: "pointer",
                padding: "0 4px",
                lineHeight: 1,
                color: "#333",
              }}
            >
              &times;
            </button>
          </div>
          <div className="modal-body p-3 text-center">
            <audio
              ref={audioRef}
              controls
              autoPlay
              src={audioUrl}
              style={{ width: "100%", outline: "none" }}
            >
              Your browser does not support the audio element.
            </audio>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayerPopup;
